export default (value) => {
  return parseFloat(value).toFixed(1)
}



// WEBPACK FOOTER //
// ./src/filters/temperature.js